import DocumentationService from "../services/documentation-service/DocumentationService";

export default class Route {
    static shouldOrder = routeItems =>
        routeItems.some(routeItem => typeof routeItem.order === "number");

    static orderRouteItems = routeItems =>
        routeItems.sort((l, g) => l.order - g.order);

    static getRoutesWithScope = routes => {
        return routes.filter(
            item => item.requiredScopes && item.requiredScopes.length > 0
        );
    };

    static getRoutesWithoutScope = routes => {
        return routes.filter(
            item => item.requiredScopes && item.requiredScopes.length === 0
        );
    };

    static checkHasDocFromProfile = async fileName => {
        const documentation = await DocumentationService.getDocumentation(
            fileName
        );
        return !!documentation;
    };

    static removeRouteWithoutDocumentationFile = async (
        routes,
        organizationName,
        userProfile
    ) => {
        const fileName = `${organizationName}_${userProfile}`;
        const hasDoc = await this.checkHasDocFromProfile(fileName);
        if (hasDoc) {
            return routes;
        }

        return routes?.filter(route => route?.to !== "/getting-started");
    };
}
